/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PresenterFixedAssetFilter, PresenterResponse } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class SelectAll<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get the fixed asset biids with filters
   *
   * @tags select_all
   * @name PostSearchFixedAssetsSelectAll
   * @summary Get the fixed asset biids with filters
   * @request POST:/search/fixed_assets/select_all
   */
  postSearchFixedAssetsSelectAll = (
    body: PresenterFixedAssetFilter,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: string[];
      },
      any
    >({
      path: `/search/fixed_assets/select_all`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
